// extracted by mini-css-extract-plugin
export default {"pdfDocumentModal":"pdfDocumentModal_pdfDocumentModal__N3Vpf"};